import React from "react";
import { Badge, Button } from "reactstrap";

const getEnrollmentColumns = ({ formatDate, canceling, onCancel }) => [
    {
        label: "#",
        key: "index",
        style: { width: "40px" },
        render: (row, index, { page, rowsPerPage }) => (
            <span className="text-muted fw-bold">
                {(page - 1) * rowsPerPage + index + 1}
            </span>
        )
    },
    {
        label: "Tipo",
        key: "type",
        render: (row) => {
            const isRegular = row.type === 'regular';
            return (
                <Badge
                    color={isRegular ? "primary" : "warning"}
                    className="font-size-12 px-2 py-1"
                    pill
                >
                    <i className={`mdi ${isRegular ? 'mdi-school' : 'mdi-star'} me-1`}></i>
                    {isRegular ? "Regular" : "Experimental"}
                </Badge>
            );
        }
    },
    {
        label: "Turma",
        key: "idClass",
        render: (row) => {
            const day = row.weekdayLabel || "";
            const time = row.startTime && row.endTime ? `${row.startTime} — ${row.endTime}` : "";
            const prof = row.employeeName ? `Prof. ${row.employeeName.split(" ")[0]}` : "";
            const activity = row.activityName || "";

            if (!day && !time && !prof) {
                return <span className="text-muted">—</span>;
            }

            return (
                <div className="d-flex flex-column gap-1">
                    {activity && <span className="fw-bold text-dark font-size-13">{activity}</span>}
                    <div className="d-flex align-items-center gap-2 text-muted font-size-12">
                        {day && <span><i className="mdi mdi-calendar-outline me-1"></i>{day}</span>}
                        {time && <span><i className="mdi mdi-clock-outline me-1"></i>{time}</span>}
                    </div>
                    {prof && <span className="text-muted font-size-12"><i className="mdi mdi-account-outline me-1"></i>{prof}</span>}
                </div>
            );
        }
    },
    {
        label: "Data Início",
        key: "startDate",
        render: (row) => formatDate(row.startDate || row.sessionDate)
    },
    {
        label: "Status",
        key: "status",
        render: (row) => {
            const isActive = row.status === 'active';
            return (
                <Badge
                    color={isActive ? "success" : "danger"}
                    className="font-size-12 px-2 py-1"
                    pill
                >
                    <i className={`mdi ${isActive ? 'mdi-check-circle' : 'mdi-close-circle'} me-1`}></i>
                    {isActive ? "Ativa" : "Cancelada"}
                </Badge>
            );
        }
    },
    {
        label: "Ações",
        key: "actions",
        headerClassName: "text-end",
        className: "text-end",
        render: (row) => {
            if (row.status !== 'active') return null;
            const isCanceling = canceling === row.id;
            return (
                <Button
                    color="danger"
                    size="sm"
                    className="btn-soft-danger border-0 rounded-0"
                    disabled={isCanceling}
                    onClick={() => onCancel(row)}
                >
                    {isCanceling ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-1" />
                            Cancelando...
                        </>
                    ) : (
                        <>
                            <i className="mdi mdi-cancel me-1"></i>
                            Cancelar
                        </>
                    )}
                </Button>
            );
        }
    }
];

export default getEnrollmentColumns;
